import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Locker } from "../../shared/data.service";
import { LockerBulkAssignRequest } from "../../shared/LockerBulkAssignRequest";

@Component({
	selector: "app-assign-lockers",
	templateUrl: "./assign-lockers.component.html",
	styleUrls: ["./assign-lockers.component.css"],
})
export class AssignLockersComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private LockerService: DataService_Locker
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.School = this.dialogConfig.data.School;
		this.lstLocker = this.dialogConfig.data.SelectedLockers;

		this.loadStudents();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	School: any;
	lstStudents: any;

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLocker: any;
	lstLocker: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LockerNum", header: "Locker" },
		{ field: "Comment", header: "Locker Comment" },
		// { field: 'AssignedComment', header: 'Assign Comment' },
		// { field: 'Student', header: 'Student' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStudents() {
		this.loading = true;

		var result = this.LockerService.LockerAssignStudentsSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstStudents = response;

				for (var z = 0; z < this.lstLocker.length; z++) {
					var next = this.lstLocker[z];

					next.PersonID = this.lstStudents[0].PersonID;
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onAssign() {
		this.errorMessage = "";

		//
		// Error handling
		//

		//Multiple to 1 student confirm
		let StudentCount: Map<number, number> = new Map();

		for (var z = 0; z < this.lstLocker.length; z++) {
			var next = this.lstLocker[z];

			if (next.PersonID > 0) {
				var data = StudentCount.get(next.PersonID) == undefined ? 0 : StudentCount.get(next.PersonID);

				StudentCount.set(next.PersonID, data + 1);
			}
		}

		var lstStudentRepeats: any = [];

		StudentCount.forEach((value, key) => {
			if (value > 1) {
				// console.log("PersonID " + key + " appears " + value + " times");
				lstStudentRepeats = [...lstStudentRepeats, key];
			}
		});

		if (lstStudentRepeats.length > 0) {
			this.ConfirmRepeat(lstStudentRepeats);
		} else {
			this.FinishAssign();
		}
	}

	//
	// You are about to assign multiple lockers to x students
	//
	ConfirmRepeat(lstPersonIDs) {
		var lstPersonNames: any = [];

		for (var z = 0; z < lstPersonIDs.length; z++) {
			var next = lstPersonIDs[z];

			// console.log("Next Person ID");
			// console.log(next);

			for (var i = 0; i < this.lstStudents.length; i++) {
				var nextPerson = this.lstStudents[i];

				// console.log("Next Student in list");
				// console.log(nextPerson);

				if (next == nextPerson.PersonID) {
					// console.log("Match");
					lstPersonNames = [...lstPersonNames, nextPerson.PersonName];
					break;
				}
			}
		}

		// console.log("List of person names");
		// console.log(lstPersonNames);

		var MSG = "The following students have multiple lockers assigned: ";

		for (var z = 0; z < lstPersonNames.length; z++) {
			var next = lstPersonNames[z];

			MSG += next;

			if (z != lstPersonNames.length - 1) {
				MSG += ",";
			} else {
				MSG += ".";
			}
		}

		MSG += " Do you want to continue?";

		this.confirmationService.confirm({
			key: "confirmassign",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Multiple Lockers",
			icon: "fa",
			accept: () => {
				this.FinishAssign();
			},
			reject: () => {},
		});
	}

	FinishAssign() {
		//
		// Create Request
		//

		this.processing = true;

		var lstLIDs: number[] = [];
		var lstPIDs: number[] = [];
		var lstCom: string[] = [];

		for (var z = 0; z < this.lstLocker.length; z++) {
			var next = this.lstLocker[z];

			lstLIDs = [...lstLIDs, next.LockerID];
			lstPIDs = [...lstPIDs, next.PersonID];
			lstCom = [...lstCom, next.AssignedComments];
		}

		let parms: LockerBulkAssignRequest = {
			SchoolID: this.School.SchoolID,
			lstLockerIDs: lstLIDs,
			lstPersonIDs: lstPIDs,
			lstComments: lstCom,
		};

		//
		// Call SP
		//

		var result = this.LockerService.LockerBulkAssign(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "assign",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Lockers were assigned students successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "assign",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign students to the Lockers",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClose() {
		for (var z = 0; z < this.lstLocker.length; z++) {
			var next = this.lstLocker[z];
			next.AssignedComments = "";
			next.PersonID = 0;
		}

		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedLocker = val.data;
	}
	onRowUnselect(val) {
		this.SelectedLocker = null;
	}
	onRowDblClick(Locker) {
		this.SelectedLocker = Locker;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	////////////////////////////////////////////
}
